module.exports = __webpack_public_path__ + "static/media/nr4.7cce993c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/icons/nr4.svg
// module id = 227
// module chunks = 0